function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#000000",
  fillRule: "nonzero",
  opacity: 0,
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M18,3 L6,3 C4.34314575,3 3,4.34314575 3,6 L3,18 C3,19.6568542 4.34314575,21 6,21 L18,21 C19.6568542,21 21,19.6568542 21,18 L21,6 C21,4.34314575 19.6568542,3 18,3 Z M6,5 L18,5 C18.5522847,5 19,5.44771525 19,6 L19,14.36 L15.8,11.63 C14.7774876,10.7886601 13.3025124,10.7886601 12.28,11.63 L5,17.7 L5,6 C5,5.44771525 5.44771525,5 6,5 Z M18,19 L6.56,19 L13.56,13.16 C13.8361039,12.954985 14.2138961,12.954985 14.49,13.16 L19,17 L19,18 C19,18.5522847 18.5522847,19 18,19 Z",
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#000000",
  fillRule: "nonzero",
  cx: 8,
  cy: 8.5,
  r: 1.5
}));

function SvgIconStorefrontImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStorefrontImg);
export default __webpack_public_path__ + "static/media/icon_storefront_img.25795f5d.svg";
export { ForwardRef as ReactComponent };